import React from "react";

function IronPrice() {
    return (
        <section id="iron_price" className="iron_price page-section" style={{ background: "#99ea24" }}>
            <div className="container-xl">
                <div className="row align-items-center">
                    <div className="col-xxl-4 col-lg-3 col-md-12 col-sm-12 ztyu004">
                        <h2 className="sec_title">Iron Pricing</h2>
                    </div>
                    <div className="col-xxl-8 col-lg-9 col-md-12 col-sm-12">
                        <div className="iron_content_price">
                            <div className="iron_price_box">
                                <div className="iron_price_content">
                                    <div className="iron_img_icon">
                                        <img src={require('../../assets/images/forewardIronsSquareSatinChromeIron-PhotoRoom.png')} alt="" />
                                    </div>
                                    <div className="iron_price">
                                        <h3>Satin</h3>
                                        <div className="iron_price_price hide_mobile">
                                            <h4>$160 <span>per iron </span></h4> 
                                        </div>
                                        <div className="iron_price_price show_mobile">
                                            <h4>$160 <br /> <span>per iron </span></h4> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="iron_price_box">
                                <div className="iron_price_content">
                                    <div className="iron_img_icon">
                                        <img src={require('../../assets/images/forewardIronsSquareBlackIron-PhotoRoom.png')} alt="" />
                                    </div>
                                    <div className="iron_price">
                                        <h3>Black</h3>
                                        <div className="iron_price_price hide_mobile">
                                            <h4>$180 <span>per iron </span></h4> 
                                        </div>
                                        <div className="iron_price_price show_mobile">
                                            <h4>$180 <br /> <span>per iron </span></h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="iron_price_box">
                                <div className="iron_price_content">
                                    <div className="iron_img_icon">
                                        <img src={require('../../assets/images/forewardIronsSquareCopperIron-PhotoRoom_(1).png')} alt="" />
                                    </div>
                                    <div className="iron_price">
                                        <h3>Copper</h3>
                                        <div className="iron_price_price hide_mobile">
                                            <h4>$200 <span>per iron </span></h4> 
                                        </div>
                                        <div className="iron_price_price show_mobile">
                                            <h4>$200 <br /> <span>per iron </span></h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default IronPrice;